export default __webpack_public_path__ + "static/cert3-58d25f1679bc952226c75206ed21a091.jpg";